'use strict';

const formatDate = (date) => {
  const temp1 = Date.parse(date);
  const temp2 = new Date(temp1);
  const lastUpdate = temp2.getDate() + '/' + (temp2.getMonth() + 1) + '/' + temp2.getFullYear() + ' at ' + formatAMPM(temp2);
  return lastUpdate;
};

const formatAMPM = (date) => {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
};
export default formatDate;
